import { Star, Quote } from "lucide-react";
import { Reveal, Chapter } from "@/components/Reveal";

const TESTIMONIALS = [
  {
    name: "Annie-Pier Trudel",
    date: "il y a 3 mois",
    text: "Nous avons eu une excellente expérience grâce à ses services pour l'achat de notre véhicule. Il s'est occupé de tout le processus avec professionnalisme et efficacité, ce qui nous a évité énormément de temps et de stress liés aux démarches.",
  },
  {
    name: "Guillaume Jacques",
    date: "il y a 3 mois",
    text: "Services excellent et rapide. Toujours disponible quand on l'appelle. Je le recommande à tous.",
  },
  {
    name: "Justin Hébert",
    date: "il y a 3 mois",
    text: "Super expérience avec Mike. Il m'a expliqué plein de choses que je savais pas, m'a permis de sauver plusieurs milliers de dollars par ses connaissances du domaine. Réponds toujours rapidement, super poli, je l'ai déjà recommandé à plusieurs personnes. Merci !",
  },
];

const Stars = () => (
  <div className="flex gap-1" aria-label="5 étoiles sur 5">
    {[...Array(5)].map((_, i) => (
      <Star key={i} size={14} className="text-gold" fill="currentColor" strokeWidth={0} />
    ))}
  </div>
);

export default function Testimonials() {
  return (
    <section id="temoignages" data-testid="testimonials-section" className="py-24 md:py-32 lg:py-36">
      <div className="container-x">
        <Reveal>
          <Chapter number="07" label="Témoignages" />
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.1] tracking-tight max-w-2xl">
              Ils nous ont confié
              <br />
              <span className="gold-text">leur automobile.</span>
            </h2>
            <div className="flex flex-col sm:flex-row sm:items-center gap-4">
              <div className="flex items-center gap-3">
                <Stars />
                <p className="text-sm text-slate-400 font-light">5 étoiles sur 5 — avis Google</p>
              </div>
              <a
                data-testid="testimonials-google-link"
                href="https://www.google.com/search?q=Gestion+Automobile+Ex%C3%A9cutive+avis"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-outline !px-6 !py-3 !text-[11px] whitespace-nowrap sm:ml-4"
              >
                Voir tous nos avis
              </a>
            </div>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={0.1 * i}>
              <figure
                data-testid={`testimonial-card-${i + 1}`}
                className="card-lux h-full flex flex-col relative"
              >
                <Quote
                  size={56}
                  strokeWidth={0.75}
                  className="absolute top-6 right-7 text-gold/10"
                  aria-hidden="true"
                />
                <Stars />
                <blockquote className="mt-6 font-display text-lg sm:text-xl text-slate-100 leading-relaxed flex-1">
                  « {t.text} »
                </blockquote>
                <figcaption className="mt-8 pt-5 border-t border-white/[0.07] flex items-center gap-4">
                  <span className="w-10 h-10 rounded-full border border-gold/40 bg-gold/5 flex items-center justify-center font-display text-gold text-lg">
                    {t.name.charAt(0)}
                  </span>
                  <div>
                    <p className="text-sm text-white font-medium">{t.name}</p>
                    <p className="text-xs text-slate-500 font-light">Avis Google · {t.date}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
